'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _isEmpty = require('lodash/isEmpty');var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _Modal = require('../../components/Modal/Modal');var _Modal2 = _interopRequireDefault(_Modal);

var _MobileContacts = require('./MobileContacts.scss');var styles = _interopRequireWildcard(_MobileContacts);
var _CompanyContact = require('../PropertyDetailedInfo/BasicInformation/CompanyContact/CompanyContact');var _CompanyContact2 = _interopRequireDefault(_CompanyContact);
var _RealtorContact = require('../PropertyDetailedInfo/BasicInformation/RealtorContact/RealtorContact');var _RealtorContact2 = _interopRequireDefault(_RealtorContact);
var _RegularUserContact = require('../PropertyDetailedInfo/BasicInformation/RegularUserContact/RegularUserContact');var _RegularUserContact2 = _interopRequireDefault(_RegularUserContact);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Module
// Components
// Styles
var MobileContacts = function (_Component) {_inherits(MobileContacts, _Component);function MobileContacts() {_classCallCheck(this, MobileContacts);return _possibleConstructorReturn(this, _Component.apply(this, arguments));}MobileContacts.prototype.componentWillUnmount = function componentWillUnmount() {
    this.props.onRequestClose();
  };MobileContacts.prototype.

  render = function render() {var _props =













    this.props,isOpen = _props.isOpen,onRequestClose = _props.onRequestClose,isRtl = _props.isRtl,children = _props.children,locale = _props.locale,translate = _props.translate,realEstateData = _props.realEstateData,onSendMessage = _props.onSendMessage,isCompanyActive = _props.isCompanyActive,contacts = _props.contacts,onRevealPhone = _props.onRevealPhone,shouldRemovePropertyRealtorIcon = _props.shouldRemovePropertyRealtorIcon;var

    isRealtorProperty = realEstateData.isAgent;
    return (
      _react2.default.createElement(_Modal2.default, {
          isOpen: isOpen,
          onRequestClose: onRequestClose,
          className: 'mobileContacts',
          isRtl: isRtl },

        children ||
        _react2.default.createElement('div', { className: styles.contacts },
          _react2.default.createElement('strong', { className: styles.contactInformationTitle },
            translate(
            'propertyDetails',
            'contacts',
            'contactInformationTitle')),



          isRealtorProperty &&
          _react2.default.createElement('div', { className: styles.contactsList },
            _react2.default.createElement(_CompanyContact2.default, {
              shouldRemovePropertyRealtorIcon:
              shouldRemovePropertyRealtorIcon,

              locale: locale,
              translate: translate,
              realEstateData: realEstateData,
              onScrollToForm: onSendMessage,
              isCompanyActive: isCompanyActive,
              className: styles.contact }),

            !(0, _isEmpty2.default)(contacts.primary) &&
            _react2.default.createElement(_RealtorContact2.default, {
              isMobile: true,
              onRevealPhone: onRevealPhone,
              locale: locale,
              translate: translate,
              contact: contacts.primary,
              className: styles.contact }),


            !(0, _isEmpty2.default)(contacts.secondary) &&
            _react2.default.createElement(_RealtorContact2.default, {
              isMobile: true,
              onRevealPhone: onRevealPhone,
              locale: locale,
              translate: translate,
              contact: contacts.secondary,
              className: styles.contact })),




          !isRealtorProperty &&
          _react2.default.createElement(_RegularUserContact2.default, {
            isMobile: true,
            locale: locale,
            translate: translate,
            contact: contacts.primary,
            onSendMessage: onSendMessage,
            onRevealPhone: onRevealPhone }))));






  };return MobileContacts;}(_react.Component);exports.default = MobileContacts;


MobileContacts.propTypes = {
  contacts: _propTypes2.default.object,
  locale: _propTypes2.default.string,
  isOpen: _propTypes2.default.bool,
  isCompanyActive: _propTypes2.default.bool,
  onRequestClose: _propTypes2.default.func,
  isRtl: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  realEstateData: _propTypes2.default.object,
  onMapTitle: _propTypes2.default.array,
  children: _propTypes2.default.node,
  contactButton: _propTypes2.default.node,
  onSendMessage: _propTypes2.default.func,
  onRevealPhone: _propTypes2.default.func,
  shouldRemovePropertyRealtorIcon: _propTypes2.default.bool };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/MobileContacts/MobileContacts.js
// module id = 1212
// module chunks = 0